module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 6-b99ee08bac6cbcd15ad19554d055d8f6.jpg";